import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY
const isDemo = import.meta.env.DEV && import.meta.env.MODE === 'demo'

if (!isDemo && (!url || !anonKey)) {
  throw new Error(
    'VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY precisam estar configurados no .env.local'
  )
}

export const supabase = isDemo ? (await import('../demo/supabase.js')).demoSupabase : createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
